var _circle, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversationClosedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "#E6E9ED",
    stroke: "#C9CED6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 8,
    width: 6,
    height: 4,
    rx: 1,
    fill: "#7A8CA5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8V6.5a1.5 1.5 0 013 0V8",
    fill: "none",
    stroke: "#7A8CA5",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationClosedIcon);
export default __webpack_public_path__ + "static/media/conversation-closed-icon.0e66e5e5594ce03618512fea15c99dc3.svg";
export { ForwardRef as ReactComponent };